module.exports = __webpack_public_path__ + "static/media/thumbnail.96c2dd80.jpg";